module.exports = __webpack_public_path__ + "static/media/per1.ef973ba9.webp";